module.exports = __webpack_public_path__ + "static/media/empty-portfolio.4d5d92b0.svg";